// extracted by mini-css-extract-plugin
module.exports = {"assignmentRow":"styles_assignmentRow__1V8rD","titleRowTablet":"styles_titleRowTablet__Or3Ip","headerRow":"styles_headerRow__sURBK","sectionRow":"styles_sectionRow__2vs2v"};